import { defineStore } from "pinia";
import { ref, computed } from "vue";

import type { GetShiftScheduleQuery } from "@/sdk";

export const useDriverDutyStore = defineStore("driverDutyStore", () => {
	const shiftSchedule = ref<GetShiftScheduleQuery["shift_schedule"][0] | null>(
		null,
	);
	const setShiftSchedule = (newShiftSchedule: any) => {
		shiftSchedule.value = newShiftSchedule;
	};
	const getVehicleID = () => {
		// V2-first: prefer direct vehicle relationship, fallback to driver_vehicle
		return (
			shiftSchedule.value?.vehicle?.id ||
			shiftSchedule.value?.driver_vehicle?.vehicle?.id ||
			null
		);
	};

	const vehicleConfigurations = computed(() => {
		// V2-first: prefer direct vehicle relationship, fallback to driver_vehicle
		return (
			shiftSchedule.value?.vehicle?.vehicle_configurations ??
			shiftSchedule.value?.driver_vehicle?.vehicle?.vehicle_configurations ??
			[]
		);
	});

	const getVehicleConfigValue = (key: string): string | null => {
		const config = vehicleConfigurations.value.find(
			(c) => c.key === key && c.is_active !== false,
		);
		return config?.value ?? null;
	};

	const isAutomationEnabled = computed(() => {
		return getVehicleConfigValue("is_automation_enabled") === "true";
	});

	return {
		shiftSchedule,
		setShiftSchedule,
		getVehicleID,
		vehicleConfigurations,
		getVehicleConfigValue,
		isAutomationEnabled,
	};
});
